export default "__VITE_ASSET__IPZBVg8D__"